// extracted by mini-css-extract-plugin
export default {"text-links-container":"kOqls","text-link-advert":"QZYtl"};